import type { CreatorActivity } from "@unbox/api";
import { CollapsibleActivityItem } from "./collapsible-activity-item";

export interface ActivityDaySectionProps {
  date: string; // e.g., "Tuesday - 16th Jan 2025"
  activities: CreatorActivity[];
  creatorAvatar?: string | null;
  brandAvatar?: string | null;
  creatorName?: string | null;
}

export const ActivityDaySection = ({
  date,
  activities,
  creatorAvatar,
  brandAvatar,
  creatorName,
}: ActivityDaySectionProps) => {
  return (
    <div className="mb-6 w-[550px]">
      {/* Day Header - NOT collapsible, just a display with line */}
      <div className="py-3 px-0 flex items-center gap-3">
        <h3 className="text-sm font-medium text-secondary whitespace-nowrap">{date}</h3>
        <div className="flex-1 h-[0.5px] bg-border-primary" />
      </div>

      {/* Activities List with Timeline */}
      <div className="relative">
        {activities.map((activity, index) => {
          const isLast = index === activities.length - 1;

          return (
            <CollapsibleActivityItem
              key={activity.id}
              activity={activity}
              creatorAvatar={creatorAvatar}
              brandAvatar={brandAvatar}
              creatorName={creatorName}
              showConnectorLine={!isLast}
            />
          );
        })}
      </div>
    </div>
  );
};
